import {FC} from "react";
import {Modal} from '@sainsburys-tech/luna-modal'
import DuTypeAddFormAdd from "./duTypeFields";
import {AddPopupType} from "../../../Interfaces/IAddFieldModalProps";
import "./duTypeModalAdd.scss"

const DuTypePopupAdd: FC<AddPopupType> = ({
                                            isOpen,
                                            handleClose,
                                            handleAddCallback: handleAdd,
                                            title,
                                            isEdit
                                          }) => {
  const closeHandler = () => {
    handleClose(false)
  }

  return (
      <>
        <div className="duTypeModal">
          <Modal
              classNanme="duTypeModal"
              small
              handleClose={() => closeHandler()}
              open={isOpen}
              headingId="info-modal"
              stickyHeader="Sticky Header"
              restrictClose={true}
          >
            {/*<ModalHeading element="h4">{title}</ModalHeading>*/}
            <DuTypeAddFormAdd closeModal={closeHandler} isEdit={isEdit}/>
          </Modal>
        </div>
      </>
  )
}

export default DuTypePopupAdd;